import CustomIcon from "../CustomIcon";
import { track } from "../../analytics";
import Button from "../Inputs/Button";
import {
  CONTACT,
  FINANCIAL_ADVISER_ID,
} from "../../__constants__";
import Link from "next/link";

export default function HelpPanel({ verticalId }) {
  const discoverUrl = 'https://discover.vouchedfor.co.uk/?utm_source=directorybanner'

  const onRequestClick = () => {
    track("Clicked help tile", {
      category: "Search",
      label: discoverUrl,
    });
  }

  return (
    <div className="min-h-[150px] w-[calc(100%+16px)] -mx-2 xs:mx-0 xs:w-full py-10 xs:p-4 xs:px-10 items-center bg-pale-mint-green text-nowrap flex flex-nowrap flex-col max-sm:gap-4 sm:flex-row box-border justify-between">
      <div className="grow-0 max-sm:text-center">
        <div className="flex flex-col">
          <h4 className="text-[1.5rem] md:text-[2.125rem] leading-none font-bold m-0 mb-2">
            Need help?
          </h4>

          <p className="text-[1rem] md:text-[20px] font-normal leading-[1.5] m-0 text-wrap">
            Let our team find the right adviser for you
          </p>
        </div>
      </div>

      <div className="flex items-end font-bold content-between px-4">
        <div className="flex justify-center items-center">
          <a className="no-underline text-primary-blue" href={`tel:${CONTACT.ACCOUNTS_TEAM_NUMBER}`}>
            <CustomIcon icon="phone" color="navt" />
          </a>
            
          <h5 className="font-bold text-[1.5rem] leading-[1.334] m-0 -mt-2">
            <a className="no-underline text-primary-blue" href={`tel:${CONTACT.ACCOUNTS_TEAM_NUMBER}`}>
              {CONTACT.ACCOUNTS_TEAM_NUMBER}
            </a>
          </h5>
        </div>
      </div>

      <div className="flex items-end content-between max-sm:text-center">
        <div className="flex justify-center">
          <div>
            <p className="md:font-bold leading-[1.5] md:text-[1.1rem] m-0">
              Free to call, no obligation
            </p>

            <p className="md:font-bold leading-[1.5] md:text-[1.1rem] m-0">
              100% impartial service
            </p>

            {verticalId === FINANCIAL_ADVISER_ID && (
              <div className="mt-2 text-center">
                <Link href={discoverUrl}>
                  <a>
                    <Button
                      className='py-1'
                      text="Let's go"
                      onClick={onRequestClick}
                    />
                  </a>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
